<template>
  <div class="home">
    <main>
    <article>
      <h1 class="header_pdf">FF Lunestedt</h1>
      <img src="@/components/images/feuerwehrlunestedt.jpg" class="open_pdf"/>
    </article>
</main>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {

  }
}
</script>
<style scoped>
.header_pdf {
  margin: auto;
  padding-bottom: 20px;
  padding-top: 20px;
}
.open_pdf {
  width: 70%;
  height: auto;
  margin: auto;
}
@media(max-width:900px) {
  .open_pdf {
  width: 100%;
}
.home {
  padding: 0;
}
}
article {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>